import {BseDto, SeDto} from "../../autogen/bff-api";

export const eventIsAwarded = (event: BseDto | SeDto): boolean => {
    return event.status === 'Awarded'
}
